import { InnerBox } from "@/components/elements/InnerBox";
import { Grid, Stack, Typography } from "@mui/material";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { black } from "@/theme/colors";
import { TGetCompanyDto } from "@/api/services/admin/company/dtos/get-company.dto";
import { FC } from "react";

type TCompanyDescriptionDetailProps = {
  company: TGetCompanyDto;
};

export const CompanyDescriptionDetail: FC<TCompanyDescriptionDetailProps> = ({ company }) => {
  return (
    <InnerBox padding={3}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <ItemInfo label="紹介会社情報" value={company?.referralCompanyInfo} type="textArea" isShowDivider={false} />
        </Grid>
        <Grid item xs={4}>
          <ItemInfo label="備考" value={company?.note} type="textArea" isShowDivider={false} />
        </Grid>
        <Grid item xs={4}>
          <Stack direction="row" spacing={2} justifyContent="space-around">
            <Stack direction="column" spacing={2} alignItems="center">
              <Typography variant="cap12" color={black[70]}>
                外国人数
              </Typography>
              <Typography variant="head24Bold">{company?.currentLearnerCount ?? 0} 人</Typography>
            </Stack>
            <Stack direction="column" spacing={2} alignItems="center">
              <Typography variant="cap12" color={black[70]}>
                有効アカウント数
              </Typography>
              <Typography variant="head24Bold">{company?.activeAccountLearnerCount ?? 0} 人</Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
